import i18n from 'helpers/i18n';
import messages from './messages';

export const lrRoles = [
  { value: 'lr_admin', label: 'Admin' },
  { value: 'lr_coach', label: 'Coach' },
  { value: 'lr_educator', label: 'Educator' }
];

export const dcRoles = [
  { value: 'data_entry', label: 'Data Entry' },
  { value: 'observer', label: 'Observer' },
  { value: 'supervisor', label: 'Supervisor' }
];

export const iiRoles = [
  { value: 'ii_admin', label: 'Admin' },
  { value: 'ii_coach', label: 'Coach' },
  { value: 'ii_educator', label: 'Educator' }
];

export const statusList = [
  { value: 'accepted', label: 'Active' },
  { value: 'invited', label: 'Invited' },
  { value: 'uploaded', label: 'Uploaded' }
];

export const TABLE_TYPES = {
  CC_ACTIVE_USERS: 'CC_ACTIVE_USERS',
  DC_ACTIVE_USERS: 'DC_ACTIVE_USERS',
  LR_ACTIVE_USERS: 'LR_ACTIVE_USERS',
  LR_COACH_GROUPS: 'LR_COACH_GROUPS',
  II_ACTIVE_USERS: 'II_ACTIVE_USERS',
  UNSUBSCRIBED_USERS: 'UNSUBSCRIBED_USERS'
};

export const DC_TABLE_TYPE_OPTIONS = [
  {
    value: TABLE_TYPES.DC_ACTIVE_USERS,
    text: i18n.ft(messages.activeUsers)
  },
  {
    value: TABLE_TYPES.UNSUBSCRIBED_USERS,
    text: i18n.ft(messages.unsubscribedUsers)
  }
];

export const CC_TABLE_TYPE_OPTIONS = [
  {
    value: TABLE_TYPES.CC_ACTIVE_USERS,
    text: i18n.ft(messages.activeUsers)
  },
  {
    value: TABLE_TYPES.UNSUBSCRIBED_USERS,
    text: i18n.ft(messages.unsubscribedUsers)
  }
];

export const LR_TABLE_TYPE_OPTIONS = [
  {
    value: TABLE_TYPES.LR_ACTIVE_USERS,
    text: i18n.ft(messages.activeUsers)
  },
  {
    value: TABLE_TYPES.UNSUBSCRIBED_USERS,
    text: i18n.ft(messages.unsubscribedUsers)
  },
  {
    value: TABLE_TYPES.LR_COACH_GROUPS,
    text: i18n.ft(messages.coachGroups)
  }
];

export const II_TABLE_TYPE_OPTIONS = [
  {
    value: TABLE_TYPES.II_ACTIVE_USERS,
    text: i18n.ft(messages.activeUsers)
  },
  {
    value: TABLE_TYPES.UNSUBSCRIBED_USERS,
    text: i18n.ft(messages.unsubscribedUsers)
  }
];

export function getTableTypeOptions(subscription: string) {
  if (subscription === 'data_collection') {
    return DC_TABLE_TYPE_OPTIONS;
  }

  if (subscription === 'class_connect') {
    return CC_TABLE_TYPE_OPTIONS;
  }

  if (subscription === 'instant_insights') {
    return II_TABLE_TYPE_OPTIONS;
  }

  return LR_TABLE_TYPE_OPTIONS;
}

export function getTableFilterRoles(subscription: string) {
  if (subscription === 'data_collection') {
    return dcRoles;
  }

  if (subscription === 'class_connect') {
    return [];
  }

  if (subscription === 'instant_insights') {
    return iiRoles;
  }

  return lrRoles;
}
